import type { FormValues } from '../../agent/types';

export const MOCK_FORM_DATA: Record<string, FormValues> = {
  t1: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '1',
    nomePromo: 'Rebaixa Verão 2027',
    nomeExibicao: 'Desconto de Verão — até 15% OFF',
    descricao: 'Ganhe até 15% de desconto em produtos selecionados durante o verão. Válido até 31/03/2027.',
    descricaoInterna: 'Campanha de verão Q1 2027 — budget compartilhado com time de marketing.',
    tipoDesconto: '1',
    valorDesconto: '15',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '1',
    inicioVigencia: '01/01/2027 00:00',
    fimVigencia: '31/03/2027 23:59',
    budgetAtrelado: '1',
    budgetValor: '50000',
    sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    criterioDesconto: '2',
    qtdMinima: '',
    qtdMaxima: '',
    valorMinimo: '150',
    valorMaximo: '999999',
    tipoItemIncluido: '3',
    itensIncluidos: ['Dove', 'Rexona', 'Axe'],
    eansObrigatorios: [],
    skusObrigatorios: [],
    skuCombo: '0',
    industriaFamilia: 'Unilever',
  },

  t2: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '2',
    nomePromo: 'Rebaixa Progressiva Beleza',
    nomeExibicao: 'Compre mais, economize mais!',
    descricao: 'Desconto progressivo: 5% acima de R$100, 10% acima de R$250, 15% acima de R$500 em produtos de beleza.',
    descricaoInterna: 'Campanha progressiva Q2 2027.',
    numeroCard: '1',
    valorDesconto: '5',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '2',
    inicioVigencia: '01/04/2027 00:00',
    fimVigencia: '30/06/2027 23:59',
    budgetAtrelado: '1',
    budgetValor: '75000',
    sellersIncluidos: ['Norte Sul - MT', 'Karina - AC'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1'],
    criterioDesconto: '2',
    qtdMinima: '',
    qtdMaxima: '',
    valorMinimo: '100',
    valorMaximo: '249',
    tipoItemIncluido: '3',
    itensIncluidos: ['Dove', 'TRESemmé', 'Seda'],
    eansObrigatorios: [],
    skusObrigatorios: [],
    skuCombo: '0',
    industriaFamilia: 'Unilever',
  },

  t3: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '3',
    nomePromo: 'Compre e Ganhe Shampoo',
    nomeExibicao: 'Leve 3 Pague 2 em Shampoos Selecionados',
    descricao: 'Compre 2 shampoos da família Seda e ganhe 1 condicionador grátis. Válido até 30/04/2027.',
    descricaoInterna: 'Ação A+B família cabelos Q2.',
    numeroCard: '1',
    valorDesconto: '100',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '1',
    inicioVigencia: '01/03/2027 00:00',
    fimVigencia: '30/04/2027 23:59',
    budgetAtrelado: '2',
    budgetValor: '',
    sellersIncluidos: ['Norte Sul - MT'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    valorMinimo: '',
    valorMaximo: '',
    tipoFamilia: '1',
    nomeFamilia: 'Shampoos Seda',
    industriaFamilia: 'Unilever',
    obsFamilia: '',
    skusFamilia: '7891150037250,7891150037250C12,7891150037250C3',
    qtdEANsDistintos: '2',
    qtdMinimaAtivacao: '2',
    qtdMaximaAtivacao: '999999',
    qtdFamiliasAtivacao: '1',
    familiaObrigatoria: '1',
  },

  t4a: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '4',
    tipoLista: '1',
    recompraDisponivel: 'Yes',
    nomePromo: 'Lista Mix Beleza Brasil Q2',
    nomeExibicao: 'Mix Beleza Brasil — Produtos com até 8% OFF',
    descricao: 'Lista curada com os melhores produtos de beleza com desconto exclusivo até 30/06/2027.',
    descricaoInterna: 'Lista sugerida Q2 — beleza e cuidados pessoais.',
    numeroCard: '1',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '1',
    inicioVigencia: '01/04/2027 00:00',
    fimVigencia: '30/06/2027 23:59',
    budgetAtrelado: '2',
    budgetValor: '',
    sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    nomeFamilia: 'Cuidados Cabelos',
    industriaFamilia: 'Unilever',
    obsFamilia: '',
    skusFamilia: '7891150037250,7891150037250C12',
    qtdEANsDistintos: '5',
    qtdMaximaAtivacao: '999999',
    qtdFamiliasAtivacao: '2',
    familiaObrigatoria: '1',
    posicaoFamilia: '1',
    descontoFamilia: '8',
    posicaoLista: '1',
    secaoLista: 'Beleza e bem estar',
  },

  t4b: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '4',
    tipoLista: '2',
    idListaOriginal: '987654321',
    nomePromo: 'Recompra Lista Mix Beleza Brasil Q2',
    nomeExibicao: 'Recompra Mix Beleza — Seus favoritos com desconto!',
    descricao: 'Com base na sua última compra, selecionamos os melhores produtos com desconto exclusivo. Válido até 30/06/2027.',
    descricaoInterna: 'Recompra da lista Q2 beleza.',
    numeroCard: '1',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '1',
    inicioVigencia: '01/05/2027 00:00',
    fimVigencia: '30/06/2027 23:59',
    budgetAtrelado: '2',
    budgetValor: '',
    sellersIncluidos: ['Norte Sul - MT'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    nomeFamilia: 'Cuidados Cabelos',
    industriaFamilia: 'Unilever',
    obsFamilia: '',
    skusFamilia: '7891150037250,7891150037250C12',
    posicaoFamilia: '1',
    descontoFamilia: '8',
    posicaoLista: '2',
    secaoLista: 'Beleza e bem estar',
  },

  t5: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '5',
    nomePromo: 'VERAOOFF15',
    nomeExibicao: '15% OFF em Produtos Selecionados',
    descricao: 'Use o cupom VERAOOFF15 e ganhe 15% de desconto em produtos selecionados. Válido até 31/03/2027.',
    descricaoInterna: 'Cupom verão Q1 2027.',
    tipoDesconto: '1',
    valorDesconto: '15',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '2',
    inicioVigencia: '01/01/2027 00:00',
    fimVigencia: '31/03/2027 23:59',
    budgetAtrelado: '1',
    budgetValor: '30000',
    sellersIncluidos: ['Norte Sul - MT', 'Karina - AC', 'Recol - AC'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    criterioDesconto: '2',
    qtdMinima: '',
    qtdMaxima: '',
    valorMinimo: '100',
    valorMaximo: '999999',
    codigoCupom: 'VERAOOFF15',
    qtdCupons: '999999',
    usosPorCliente: '1',
    tipoItemIncluido: '7',
    itensIncluidos: ['Unilever'],
    eansObrigatorios: [],
    skusObrigatorios: [],
    skuCombo: '0',
    industriaFamilia: 'Unilever',
  },

  t6: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '6',
    nomePromo: 'PROGRESSIVO25',
    nomeExibicao: 'Desconto Progressivo com Cupom',
    descricao: 'Use o cupom PROGRESSIVO25 e ganhe descontos crescentes: 5%, 10% ou 15% dependendo do valor da compra.',
    descricaoInterna: 'Cupom progressivo Q2 — teste de mecânica.',
    numeroCard: '1',
    valorDesconto: '5',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '2',
    inicioVigencia: '01/04/2027 00:00',
    fimVigencia: '30/06/2027 23:59',
    budgetAtrelado: '1',
    budgetValor: '45000',
    sellersIncluidos: ['Norte Sul - MT'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1'],
    criterioDesconto: '2',
    qtdMinima: '',
    qtdMaxima: '',
    valorMinimo: '200',
    valorMaximo: '499',
    codigoCupom: 'PROGRESSIVO25',
    qtdCupons: '999999',
    usosPorCliente: '3',
    tipoItemIncluido: '3',
    itensIncluidos: ['Dove', 'Rexona'],
    tipoItemExcluido: '3',
    itensExcluidos: 'KitKat,Nescafé',
    eansObrigatorios: [],
    skusObrigatorios: [],
    skuCombo: '0',
  },

  t7: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '7',
    nomePromo: 'CASHBACK250MARCO',
    nomeExibicao: 'Cashback de R$250 em Março',
    descricao: 'Compre produtos Unilever e ganhe R$250 de cashback no carrinho. Válido durante março de 2027.',
    descricaoInterna: 'Cashback março 2027 — ação especial.',
    valorDesconto: '250',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '1',
    inicioVigencia: '01/03/2027 00:00',
    fimVigencia: '31/03/2027 23:59',
    budgetAtrelado: '2',
    budgetValor: '',
    sellersIncluidos: [],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    criterioDesconto: '2',
    qtdMinima: '',
    qtdMaxima: '',
    valorMinimo: '1000',
    valorMaximo: '999999',
    codigoCupom: 'CASHBACK250MARCO',
    qtdCupons: '999999',
    usosPorCliente: '1',
    tipoItemIncluido: '7',
    itensIncluidos: ['Unilever'],
    tipoItemExcluido: '',
    itensExcluidos: '',
    eansObrigatorios: [],
    skusObrigatorios: [],
    skuCombo: '0',
  },

  t8: {
    tipoSolicitacao: '0',
    idIFC: 'n/a',
    tipoMecanica: '1',
    nomePromo: 'CIF10OFF',
    nomeExibicao: 'Compre Cif e Ganhe 10% OFF',
    descricao: 'Compre produtos Cif e ganhe 10% de desconto. Use o cupom CIF10OFF. Válido até 30/04/2027.',
    descricaoInterna: 'Ação Cif + cupom Q2 2027.',
    numeroCard: '0',
    tipoDesconto: '1',
    valorDesconto: '10',
    industria: '1',
    multiPatrocinador: '0',
    patrocinadores: 'Unilever 100%',
    cumulativa: '1',
    inicioVigencia: '01/04/2027 00:00',
    fimVigencia: '30/04/2027 23:59',
    budgetAtrelado: '1',
    budgetValor: '51520',
    sellersIncluidos: ['Norte Sul - MT', 'Supergiro - AM'],
    sellersExcecao: [],
    cnpjsIncluidos: [],
    cnpjsExcecao: [],
    canais: ['1', '2'],
    tipoPedido: ['1', '2'],
    criterioDesconto: '2',
    qtdMinima: '',
    qtdMaxima: '',
    valorMinimo: '100',
    valorMaximo: '999999',
    cupom: '2',
    codigoCupom: 'CIF10OFF',
    qtdCupons: '999999',
    usosPorCliente: '1',
    eansInclusao: [],
    eansExclusao: [],
    skusInclusao: [],
    skusExclusao: [],
    marcasInclusao: ['Dove', 'Rexona'],
    marcasExclusao: [],
    categoriasInclusao: [],
    categoriasExclusao: [],
    subcategoriasInclusao: [],
    subcategoriasExclusao: [],
    departamentosInclusao: [],
    departamentosExclusao: [],
    industriasInclusao: ['Unilever'],
    industriasExclusao: [],
    familiasInclusao: [],
    familiasExclusao: [],
    eansObrigatorios: [],
    skusObrigatorios: [],
    skuCombo: '0',
  },
};

// Keywords that trigger auto-fill for each template
export const TEMPLATE_FILL_COMMANDS: Record<string, string[]> = {
  t1: ['rebaixa-simples', 'rebaixa simples'],
  t2: ['rebaixa-progressiva', 'rebaixa progressiva'],
  t3: ['compre-e-ganhe', 'compre e ganhe'],
  t4a: ['lista-sugerida-original', 'lista sugerida original', 'lista original'],
  t4b: ['lista-sugerida-recompra', 'lista sugerida recompra', 'lista recompra', 'recompra'],
  t5: ['cupom-simples', 'cupom simples'],
  t6: ['cupom-progressivo', 'cupom progressivo'],
  t7: ['cashback'],
  t8: ['rebaixa-cupom-geral', 'rebaixa cupom geral', 'cupom geral', 'rebaixa geral'],
};
